import { CountryCode } from 'libphonenumber-js'

export const DEFAULT_PHONE_COUNTRY: CountryCode = 'US'
